 
 
 
import { DeleteUser, UpdateUser } from "./buttons";
import Status from "./status";
import Role from "./role";
import { PaginationResult } from "../../../../lib/definitions";
import { User } from "../../../../models";
import { formatDateToLocal } from "../../../../utils";
import Toggle from "../../../../components/toggle";


export default function UsersTable({
  users
}: {
  users: PaginationResult<User>;  
}) {

  return (
    <div className="mt-6 flow-root">
      <div className="inline-block min-w-full align-middle">
        <div className="rounded-lg bg-gray-50 p-2 md:pt-0">
          <div className="lg:hidden">
            {users.items?.map((user) => (
              <div
                key={user.id}
                className="mb-2 w-full rounded-md bg-white p-4"
              >
                <div className="flex items-center justify-between border-b pb-4">
                  <div>
                    <div className="mb-2 flex items-center">
                      <img
                        src={user.profileImage || "/default-profile.png"}
                        className="mr-2 rounded-full"
                        width={28}
                        height={28}
                        alt={`${user.name}'s profile picture`}
                      />
                      <p>{user.name}</p>
                    </div>
                    <p className="text-sm text-gray-500">{user.phone}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Role status={user.role} />
                    <Status status={user.status} />                    
                  </div>
                </div>
                <div className="flex w-full items-center justify-between pt-4">
                  <div className="flex flex-row gap-2">
                    <p>{user.createdAt?formatDateToLocal(user.createdAt.toString()):null}</p>
                  </div>
                  {user.id?
                  <div className="flex justify-end gap-2">
                    <UpdateUser id={user.id} />
                    {/* <DeleteUser id={user.id} /> */}
                  </div>:null}
                </div>
              </div>
            ))}
          </div>
          <table className="hidden min-w-full text-gray-900 lg:table">
            <thead className="rounded-lg text-left text-sm font-normal">
              <tr>
                <th scope="col" className="px-3 py-5 font-medium ">
                  Name
                </th>
                <th scope="col" className="px-3 py-5 font-medium">
                  Phone
                </th>
                <th scope="col" className="px-3 py-5 font-medium text-center">
                  Role
                </th>
                <th scope="col" className="px-3 py-5 font-medium text-center">
                  Status
                </th>
               
                <th scope="col" className="px-3 py-5 font-medium">
                  Created At
                </th>

                <th scope="col" className="relative py-3 pl-6 pr-3">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {users.items?.map((user) => (
                <tr
                  key={user.id}
                  className="w-full text-left border-b py-3 text-sm last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg"
                >
                  <td className="whitespace-nowrap px-3 py-3">{user.name}</td>
                  <td className="whitespace-nowrap px-3 py-3">{user.phone}</td>
                  <td className="whitespace-nowrap px-3 py-3 text-center">
                    <Role status={user.role} />
                  </td>
                  <td className="whitespace-nowrap px-3 py-3 text-center">
                    <Status status={user.status} />
                  </td>
                   
                  <td className="whitespace-nowrap px-3 py-3">
                    {user.createdAt
                      ? formatDateToLocal(user.createdAt.toString())
                      : "N/A"}
                  </td>
                  <td className="whitespace-nowrap py-3 pl-6 pr-3">
                    {user.id?
                    <div className="flex justify-end gap-3">
                      <UpdateUser id={user.id} />
                      {/* <DeleteUser id={user.id} /> */}
                    </div>:null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
